module.exports = __webpack_public_path__ + "static/stateGuardianNetwork-44b07cad99e8eae79fbd445f5dfe1eb0.png";